<template>
  <span>{{standardName}}</span>
</template>
<script>
import CustomerUtil from '@/utils/customer-util'
export default {
	name: 'Customer-Provider-Name',
  props: {
    name: {
      type: String,
      default: null,
    },
    usualName: {
      type: String,
      default: null,
    },
    force: {
      type: Boolean,
      default: false
    }
  },
	data() {
		return {
		}
	},
  computed: {
    standardName () {
      return CustomerUtil.customerName(this.name, this.usualName, this.force);
    },
  },
	methods: {

  }
}
</script>
<style>
</style>
